import { Trigger } from "@radix-ui/react-select";
import { useState, type ReactNode } from "react";

import type { Plan } from "@trip/common";

import { RadioGroup, RadioGroupItem } from "~/components/ui/radio-group";
import { Select, SelectContent, SelectItem } from "~/components/ui/select";

import { AngleDownIcon } from "./icons/angle-down";
import { Button } from "./ui/button";

export function SelectTourPlans({
  plan,
  setPlanId,
  choices,
}: {
  plan: Plan;
  setPlanId: (value: string) => void;
  choices: { name: ReactNode; id: string }[];
}) {
  const [open, setOpen] = useState(false);
  return (
    <Select
      onOpenChange={(open) => {
        setOpen(open);
      }}
      open={open}
      onValueChange={(value) => {
        setPlanId(value);
      }}
    >
      <Trigger asChild>
        <Button className="h-auto w-full justify-between gap-4 text-left">
          <div className="flex flex-col items-start">
            {choices.find((choice) => choice.id === plan.id)?.name}
          </div>
          <AngleDownIcon />
        </Button>
      </Trigger>
      <SelectContent
        align={"center"}
        className="shadow-card-search w-auto rounded-2xl border-none p-2"
      >
        {choices.map((plan) => (
          <SelectItem className="font-medium" key={plan.id} value={plan.id}>
            <span>{plan.name}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function TourPlans({
  plan,
  setPlanId,
  choices,
}: {
  plan: Plan;
  setPlanId: (value: string) => void;
  choices: { name: ReactNode; id: string }[];
}) {
  return (
    <RadioGroup
      value={plan.id}
      onValueChange={(value) => {
        setPlanId(value);
      }}
      className="text-sm"
    >
      {choices.map((plan) => (
        <RadioGroupItem className="font-medium" key={plan.id} value={plan.id}>
          {plan.name}
        </RadioGroupItem>
      ))}
    </RadioGroup>
  );
}
